import { CheckCircle } from "lucide-react";
import { VoiceConfig } from "../../../../views/marketing-pages/channels/voice/types";
import { useNavigate } from "react-router-dom";

export const CompleteStep: React.FC<{
  config: VoiceConfig;
}> = ({ config }) => {
  const navigate = useNavigate();
  function onBack() {
    navigate("/cpas-dashboard");
  }
  function voiceDashboard() {
    navigate("/voice");
  }
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 max-w-2xl mx-auto">
      <div className="flex justify-center mb-6">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center">
          <CheckCircle className="w-12 h-12 text-green-600" />
        </div>
      </div>

      <h2 className="text-2xl font-semibold text-center mb-2">
        Voice Channel Active!
      </h2>
      <p className="text-gray-600 text-center mb-8">
        Your voice channel is now configured and ready to use.
      </p>

      <div className="bg-gray-50 rounded-lg p-6 mb-6">
        <h3 className="font-semibold mb-4">Your Configuration:</h3>
        <div className="space-y-3">
          <div className="flex justify-between">
            <span className="text-gray-600">Phone Number:</span>
            <span className="font-medium">{config.selectedNumber}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Country:</span>
            <span className="font-medium">IN</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Status:</span>
            <span className="font-medium text-green-600">Active</span>
          </div>
        </div>
      </div>

      <div className="flex gap-3">
        <button
          onClick={voiceDashboard}
          className="flex-1 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium"
        >
          Go to Voice Dashboard
        </button>
        <button
          onClick={onBack}
          className="flex-1 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 font-medium"
        >
          View All Channels
        </button>
      </div>
    </div>
  );
};
